import React from 'react';

import { PartnersTableItem, PartnersTableSortableField } from 'types/state';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import {
  TableTr,
  TableWrapper,
  TableHead,
  TableTh,
  TableBody,
} from 'design/table';
import { PartnersTableRow } from 'containers/PartnersTable';

type Props = {
  items: PartnersTableItem[];
  sortedBy: PartnersTableSortableField;
  ascendingSort: boolean;
  activeItemId?: number;
  onSortChange(nextSortBy: PartnersTableSortableField): void;
  onItemClick(item: number): void;
};

export const PartnersTable = (props: Props) => {
  const {
    items,
    sortedBy,
    ascendingSort,
    activeItemId,
    onSortChange,
    onItemClick,
  } = props;

  const { partnersTable: ownDictionary } = useIntlDictionary();

  // Обработчики нажатий по заголовкам таблицы.

  const onIdClick = React.useCallback(() => {
    onSortChange('id');
  }, [onSortChange]);

  const onFullNameClick = React.useCallback(() => {
    onSortChange('fullName');
  }, [onSortChange]);

  const onEmailClick = React.useCallback(() => {
    onSortChange('email');
  }, [onSortChange]);

  const onPhoneClick = React.useCallback(() => {
    onSortChange('phone');
  }, [onSortChange]);

  // const onStatusClick = React.useCallback(() => {
  //   onSortChange('status');
  // }, [onSortChange]);

  const onClientsCountClick = React.useCallback(() => {
    onSortChange('clientsCount');
  }, [onSortChange]);

  // const onEarnedAmountClick = React.useCallback(() => {
  //   onSortChange('earnedAmount');
  // }, [onSortChange]);

  // const onPaidAmountClick = React.useCallback(() => {
  //   onSortChange('paidAmount');
  // }, [onSortChange]);

  // const onBalanceClick = React.useCallback(() => {
  //   onSortChange('balance');
  // }, [onSortChange]);

  const onLatestUpdateDateClick = React.useCallback(() => {
    onSortChange('latestUpdateDate');
  }, [onSortChange]);

  // Мемоизированные строки таблицы клиентов.
  const tableRowsNode = React.useMemo(() => {
    return items.map((item) => (
      <PartnersTableRow
        key={item.id}
        active={activeItemId === item.id}
        item={item}
        onClick={onItemClick}
      />
    ));
  }, [items, activeItemId, onItemClick]);

  return (
    <TableWrapper>
      <TableHead>
        <TableTr>
          <TableTh
            size="xs"
            sorted={sortedBy === 'id'}
            ascending={ascendingSort}
            text={ownDictionary.idColumnLabel}
            onClick={onIdClick}
          />
          <TableTh
            size="xxl"
            sorted={sortedBy === 'fullName'}
            ascending={ascendingSort}
            text={ownDictionary.fullNameColumnLabel}
            onClick={onFullNameClick}
          />
          <TableTh
            size="xl"
            sorted={sortedBy === 'email'}
            ascending={ascendingSort}
            text={ownDictionary.emailColumnLabel}
            onClick={onEmailClick}
          />
          <TableTh
            size="xl"
            sorted={sortedBy === 'phone'}
            ascending={ascendingSort}
            text={ownDictionary.phoneColumnLabel}
            onClick={onPhoneClick}
          />
          <TableTh size="m" text={ownDictionary.statusColumnLabel} />
          <TableTh
            size="m"
            sorted={sortedBy === 'clientsCount'}
            ascending={ascendingSort}
            text={ownDictionary.clientsCountColumnLabel}
            onClick={onClientsCountClick}
          />
          <TableTh size="m" text={ownDictionary.earnedAmountColumnLabel} />
          <TableTh size="m" text={ownDictionary.paidAmountColumnLabel} />
          <TableTh size="m" text={ownDictionary.balanceColumnLabel} />
          <TableTh
            size="m"
            sorted={sortedBy === 'latestUpdateDate'}
            ascending={ascendingSort}
            text={ownDictionary.latestUpdateDateColumnLabel}
            onClick={onLatestUpdateDateClick}
          />
        </TableTr>
      </TableHead>
      <TableBody>{tableRowsNode}</TableBody>
    </TableWrapper>
  );
};
